<template>
  <div v-if="ready">
    <b-container>
      <b-row class="mt-3 mb-2">
        <b-col cols="12" sm="6" class="mb-2 mb-sm-0 pr-sm-1">
          <b-button block variant="primary" :to="{ name: 'MessageAdd' }"
            >Post a message</b-button
          >
        </b-col>
        <b-col cols="12" sm="6" class="pl-sm-1">
          <si-search-input />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <si-post
            :keep-expanded="true"
            :post="post"
            @destroy="onDelete($event)"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Post from "@/components/message-board/Post";
import SearchInput from "@/components/message-board/SearchInput";
import errorHandler from "@/services/errorHandler";
import { confirmPostDelete } from "@/dialogs";

export default {
  name: "Message",
  components: {
    "si-post": Post,
    "si-search-input": SearchInput,
  },
  data: () => ({
    post: null,
    ready: false,
  }),
  computed: {
    id() {
      return this.$route.params.id || 0;
    },
  },
  methods: {
    deletePost(id) {
      this.$store.dispatch("showBusy");
      this.$store
        .dispatch("deletePost", { id })
        .then(() => {
          this.exit();
        })
        .catch((err) => {
          errorHandler(this, err);
          this.exit();
        });
    },
    exit() {
      this.$router.push({ name: "Home" });
    },
    fetchPost() {
      this.$store.dispatch("showBusy");
      this.$store
        .dispatch("fetchPost", {
          id: this.id,
          mode: "view",
        })
        .then((post) => {
          this.post = post;
          this.ready = true;
          this.$store.dispatch("hideBusy");
        })
        .catch((err) => {
          errorHandler(this, err);
          this.$store.dispatch("hideBusy");
          this.exit();
        });
    },
    async onDelete(id) {
      let result = await confirmPostDelete(this);
      if (!result) return;
      this.deletePost(id);
    },
  },
  watch: {
    id() {
      this.fetchPost();
    },
  },
  mounted() {
    this.fetchPost();
  },
  beforeDestroy() {
    this.$store.dispatch("hideBusy");
  },
};
</script>
